import React from 'react';
import '../styles/Footer.css';

const Footer: React.FC = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="footer">
      <div className="footer-content">
        <div className="footer-trees">
          <svg viewBox="0 0 100 40" preserveAspectRatio="none">
            <path d="M0 40 L10 20 L5 22 L15 8 L10 10 L20 0 L30 10 L25 8 L35 22 L30 20 L40 40 Z" fill="currentColor" opacity="0.3" />
            <path d="M30 40 L40 22 L36 24 L46 12 L42 14 L50 4 L58 14 L54 12 L64 24 L60 22 L70 40 Z" fill="currentColor" opacity="0.4" />
            <path d="M60 40 L68 25 L65 27 L73 15 L70 17 L78 6 L86 17 L83 15 L91 27 L88 25 L96 40 Z" fill="currentColor" opacity="0.3" />
          </svg>
        </div>
        <p className="footer-text">
          280 Tamarack Drive • Ronald, WA
        </p>
        <p className="footer-copyright">
          © {currentYear} All Rights Reserved
        </p>
      </div>
    </footer>
  );
};

export default Footer;
